import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminAuthProvider } from "@/context/AdminAuth";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WholesaleOrder from "@/pages/WholesaleOrder";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/wholesale-order" element={<WholesaleOrder />} />
        <Route
          path="/admin/login"
          element={
            <AdminAuthProvider>
              <AdminLogin />
            </AdminAuthProvider>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminAuthProvider>
              <AdminDashboard />
            </AdminAuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
